import { NOT_SET } from '@utils/tracking/constants';
import { track, logError } from '@tracking';

const EVENT_NAME = 'header_location.closed';

const trackHeaderLocationClosed = ({ option, locationAddress }) => () => {
  try {
    const payload = { option, locationAddress: locationAddress || NOT_SET };
    track(EVENT_NAME, payload);
  } catch (error) {
    logError(EVENT_NAME, error);
  }
};

export default trackHeaderLocationClosed;
